import React from 'react';

type PriceTagProps = {
  color?: string;
  size?: number;
};

export function PriceTag({ color = 'var(--color-green-80)', size = 16 }: PriceTagProps) {
  return (
    <svg fill='none' height={size} viewBox='0 0 16 16' width={size} xmlns='http://www.w3.org/2000/svg'>
      <path
        clipRule='evenodd'
        d='M14.6673 1.33398V8.28841L8.69336 14.2559C8.56418 14.3852 8.41039 14.4879 8.24154 14.5579C8.07274 14.6279 7.89169 14.6634 7.70898 14.6634C7.52624 14.6634 7.34524 14.6279 7.17643 14.5579C7.00757 14.4879 6.85379 14.3852 6.72461 14.2559L1.73893 9.26888C1.47987 9.00827 1.33398 8.65588 1.33398 8.28841C1.33407 7.92105 1.47994 7.56848 1.73893 7.30794L7.71289 1.33398H14.6673ZM10.6673 4.00065C9.93094 4.00065 9.33398 4.5976 9.33398 5.33398C9.33398 6.07036 9.93094 6.66732 10.6673 6.66732C11.4037 6.66732 12.0007 6.07036 12.0007 5.33398C12.0007 4.5976 11.4037 4.00065 10.6673 4.00065Z'
        fill={color}
        fillRule='evenodd'
      />
    </svg>
  );
}
